var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.quiz.isDescriptionHtmlEncoded)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.quiz.description)}}):_c('Markdown',{attrs:{"source":_vm.quiz.description}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }